/**
 * @description Renders the typing dots for the chat
 */
export const ChatTypingDots = () => {
  const baseDotClass = 'size-2 rounded-full bg-ink-medium opacity-0 animate-loading-fade';

  return (
    <div
      className="inline-flex w-fit items-center justify-center gap-1 self-start rounded-3xl bg-surface-100 px-2 py-1 leading-none"
    >
      <span className={`${baseDotClass}`} />
      <span className={`${baseDotClass} animate-delay-200`} />
      <span className={`${baseDotClass} animate-delay-400`} />
    </div>
  );
};
